import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '@features/dialog/dialog.module';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SharedModule } from '@shared/shared.module';

import { LoginPanelComponent } from './login-panel/login-panel.component';
import { LoginPanelTriggerComponent } from './login-panel-trigger/login-panel-trigger.component';

@NgModule({
    imports: [CommonModule, SharedModule, FormElementsModule, DialogModule, LoginPanelComponent, LoginPanelTriggerComponent],
    exports: [LoginPanelTriggerComponent]
})
export class LoginPanelModule {}
